import React from 'react';
import { Pulldown } from './icons';
import styles from './ListGroup.scss';

const DisabledReason = ({ children }) => (
  <div className={styles.disabledReason}>
    <div className={styles.content}>{children}</div>
  </div>
);

const ListGroup = ({ children, ...rest }) => (
  <div className={styles.group} {...rest}>
    {children}
  </div>
);

ListGroup.Title = ({ children, ...rest }) => (
  <div className={styles.title} {...rest}>
    {children}
  </div>
);

ListGroup.Title.displayName = 'ListGroup.Title';

ListGroup.Item = ({ children, as, disabled, disabledReason = null, ...rest }) => {
  const Component = as;
  return (
    <Component className={disabled ? styles.disabled : styles.item} aria-disabled={disabled} {...rest}>
      {children}
      {disabled && !!disabledReason && <DisabledReason>{disabledReason}</DisabledReason>}
    </Component>
  );
};

ListGroup.Item.displayName = 'ListGroup.Item';

ListGroup.Item.defaultProps = {
  as: 'div',
};

ListGroup.Icon = () => (
  <div className={styles.arrow}>
    <Pulldown size={10} color="#ccc" />
  </div>
);

ListGroup.Icon.displayName = 'ListGroup.Icon';

export default ListGroup;
